<template>
  <v-card>
    <v-card-title class="text-h5 align-center bb-1">
      <v-icon class="pr-2" color="primary">mdi-cash-multiple</v-icon>
      Swedish ISO 20022 Export
      <v-spacer />
      <v-btn icon @click="onClose">
        <v-icon color="primary">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="d-flex flex-column align-center justify-center py-8">
      <v-progress-circular
        :rotate="90"
        :size="100"
        :width="10"
        :value="progress"
        color="primary"
        class="mb-4"
      >
        {{ Math.round(progress) }}%
      </v-progress-circular>

      <div class="text-h6 text-center">{{ message }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SwedishValidationModal',
  props: {
    onClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    progress() {
      return this.$store.state.modal.swedishValidationProgress?.progress || 0
    },
    message() {
      return (
        this.$store.state.modal.swedishValidationProgress?.message ||
        'Processing...'
      )
    },
  },
}
</script>

<style scoped></style>
